<template>
  <div>
    <appResult></appResult>
  </div>
</template>

<script>
import PartnerList from "../../components/paywall/partner/sections/PartnerList";

export default {
  data() {
    return {};
  },
  components: {
    appResult: PartnerList,
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/partner/PartnerPanel.vue